export class JobFilterSet {
    constructor(json) {
        this.id = json.id;
        this.name = json.name;
        this.data = json.data;
    }
}
//# sourceMappingURL=JobFilterSet.js.map